import overviewJson from './fixtures/w2/overview.json'
import type { TodayMetrics, TrendMini } from './types'

interface OverviewFixture {
  today: Omit<TodayMetrics, 'ctr' | 'cvr' | 'roas'> & {
    ctr: number
    cvr: number
    roas: number
  }
  trend: TrendMini
}

const fixture = overviewJson as unknown as OverviewFixture

export const todayFixture = fixture.today
export const trendFixture = fixture.trend
export const aiQuota = { total: 30, video: 18, image: 12 } as const
export const cpaTargets: Record<string, number> = {
  'c-mug-us': 38,
  'c-shoe-us': 26,
}
